import React, {useCallback, useEffect, useRef, useState} from 'react';
import {
  Button,
  Col,
  Container,
  Form,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalHeader,
  Row
} from "reactstrap";
import {useDispatch, useSelector} from "react-redux";
import {faHandPointer, faSearch} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import ContactTableComponent from "./ContactTableComponent";
import {RootState} from "../../../Store/Reducers";
import Client from "../../../Models/Client";
import Contact from "../../../Models/Contact";
import ModalFooterWithButtons from "../ModalFooterWithButtonsComponent";
import {ModalActions} from "../../../Store/Modal/Slice";
import {CONTACTS_LIST_MODAL} from "../../../Store/Modal/Types";
import {ContactsActions} from "../../../Store/Contact/Slice";
import {ISearchContact} from "../../../Store/Contact/Types";

const ContactsListModalComponent = () => {

  const { ModalReducer : {contactsListModal} } = useSelector((state: RootState) => state);
  const client: Client =  contactsListModal.data.client;
  const searchByClient: boolean =  contactsListModal.data.searchByClient;
  const phone: string =  contactsListModal.data.phone;
  const firstRun = useRef<boolean>(true);

  const [contactSelected, setContactSelected] = useState<Contact|undefined>(undefined);
  const [search, setSearch] = useState<ISearchContact>({
    name: "",
    phone: phone !== "" ? phone : "",
    cellphone: "",
    customer: client?._KEY,
    searchByClient,
  });

  const dispatch = useDispatch();

  const onClose = (contact?: Contact) => {
    dispatch(ModalActions.closeModal({
      modal: CONTACTS_LIST_MODAL,
      result: contact
    }))
  }

  const onUpdateFields = (e: any) => {
    const { name, value } = e.currentTarget;
    setSearch((prevState: any) => ({
        ...prevState,
        [name]: value
      })
    );
  }

  const handleSearch = useCallback(() => {
    dispatch(ContactsActions.getContacts(search))
  }, [dispatch, search]);

  const onKeyDown = (e: any) => e.key === "Enter" && handleSearch();

  useEffect(() => {
    if (firstRun.current) {
      if (phone && phone !== "") handleSearch();
      if (searchByClient) handleSearch()
      firstRun.current = false;
    }
  }, [handleSearch, phone, searchByClient])

  return (
    <Modal
      isOpen={contactsListModal.open}
      size="xl"
      scrollable
    >
      <ModalHeader>CONTACTOS</ModalHeader>
      <ModalBody>
        <Row>
          <Container>
            <Form>
              <FormGroup className="row">
                <Col sm={12} md={6} lg={3}>
                  <Label>NOMBRE</Label>
                  <Input
                    name="name"
                    value={search.name}
                    onChange={onUpdateFields}
                    onKeyDown={onKeyDown}
                    bsSize="sm"
                  />
                </Col>
                <Col sm={12} md={6} lg={3}>
                  <Label>TELÉFONO</Label>
                  <Input
                    name="phone"
                    value={search.phone}
                    type="number"
                    onChange={onUpdateFields}
                    onKeyDown={onKeyDown}
                    bsSize="sm"
                  />
                </Col>
                <Col sm={12} md={6} lg={3}>
                  <Label>CELULAR</Label>
                  <Input
                    name="cellphone"
                    type="number"
                    value={search.cellphone}
                    onChange={onUpdateFields}
                    onKeyDown={onKeyDown}
                    bsSize="sm"
                  />
                </Col>
                <Col sm={12} md={6} lg={3}>
                  <Label>&nbsp;</Label>
                  <div>
                    <Button color="primary" onClick={handleSearch} size="sm">
                      <FontAwesomeIcon icon={faSearch} />&nbsp;
                      BUSCAR
                    </Button>
                  </div>
                </Col>
              </FormGroup>
            </Form>
          </Container>
        </Row>
        <ContactTableComponent
          selectable
          setContactSelected={setContactSelected}
          onClose={onClose}
        />
      </ModalBody>
      <ModalFooterWithButtons
        onSave={() => { onClose(contactSelected) }}
        onClose={() => onClose()}
        saveTitle="Seleccionar"
        saveIcon={faHandPointer}
        disabledSave={!contactSelected}
      />
    </Modal>
  );
};
export default ContactsListModalComponent;
